import React, { useState, useEffect } from 'react'
import Reusabletable from '../reusableforms/Reusabletable'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import files from "./../../../../assets/templates/register_template/Employee_Separation.xlsx"
import { getEmp_Separation, updateEmp_SeparationById, deleteEmp_SeparationById, uploadEmp_SeparationFile, multiDeleteEmp_Separations } from './../../../../services/register_redux/register_actions/Emp_Separation.action';
import EditableTable from '../../../reUsableTemplates/EditableTable/EditableTable'
import ImportFileformInputMatrix from '../../../reUsableTemplates/ImportFileform/ImportFileformInputMatrix'
import ImportFileformInputMatrixclientData from '../../../reUsableTemplates/ImportFileform/ImportFileformInputMatrixclientData'
import mainicon from "../../../../assets/register_assets/inputMatix/Employee_Separation/mainicon.png"
import { getUserRole } from "./../../../../services/global_redux/globale_actions/Role.action";
import { getCurrentMonth } from './../../../../services/global_redux/globale_actions/Currentmonth.action';
import Branch_id_icon from "../../../../assets/register_assets/inputMatix/Employee_Separation/Branch_id_icon.png"
import Client_id_icon from "../../../../assets/register_assets/inputMatix/Employee_Separation/Client_id_icon.png"
import Employee_code_icon from "../../../../assets/register_assets/inputMatix/Employee_Separation/Employee_code_icon.png"
import Employee_Separaton_date_icon from "../../../../assets/register_assets/inputMatix/Employee_Separation/Employee_Separaton_date_icon.png"
import Employee_Separation_Reason_icon from "../../../../assets/register_assets/inputMatix/Employee_Separation/Employee_Separation_Reason_icon.png"
import Employee_Separation_Current_Month_icon from "../../../../assets/register_assets/inputMatix/Employee_Separation/Employee_Separation_Current_Month_icon.png"


function EmployeeSeparation({ setLoading, showSnackbar }) {
    const [getData, setGetData] = useState([])
    const [file, setFile] = useState([])
    const [editableRow, setEditableRow] = useState(null);
    const [editedValues, setEditedValues] = useState({})
    const dispatch = useDispatch();
    const { date } = useParams();
    const [createData, setCreateData] = useState(null);
    const [editData, setEditData] = useState(null);
    const [deleteData, setDeleteData] = useState(null);
    const header = [
        { key: "emp_code", value: "Employee Code", input: "text", readOnly:true  ,icon: Employee_code_icon },
        { key: "unit_id", value: "Branch ID", input: "text",readOnly:true  ,icon: Branch_id_icon},
        { key: "client_id", value: "Organization ID", input: "text" ,readOnly:true ,icon: Client_id_icon},
        { key: "emp_separation_date", value: "Employee Separation Date", input: "date" ,icon: Employee_Separaton_date_icon},
        { key: "emp_separation_reason", value: "Employee Separation Reason", input: "text" ,icon: Employee_Separation_Reason_icon},
        { key: "separation_current_month", value: "Employee Separation Current Month", input: "date" ,readOnly:true, icon: Employee_Separation_Current_Month_icon},
    ];

    const [actionChecked, setActionChecked] = useState("");
    

    // const fetchdata = async () =>{
    //     try{
    //         const response = await dispatch(getEmp_Separation(date));
    //         if(response.data){
    //             setGetData(response.data);
    //         }else{
    //             setGetData(0);
    //         }
    //     }catch(err){
    //         console.error("Failed to fetch clients:", err);
    //     }
    // }
    const fetchdata = async () => {
        if (!date) return;
        setLoading(true);
        try {
            const response = await dispatch(getEmp_Separation(date));
            const data = Array.isArray(response?.data) ? response.data : [];
            setGetData(data);
        } catch (err) {
            console.error("Failed to fetch employee separation:", err);
            setGetData([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchdata();
    }, [dispatch, date]);



    // const handleFileUpload = async () => {
    //     if (file) {
    //         setLoading(true);

    //         const formData = new FormData();
    //         formData.append('file', file);
    //         try {
    //             const response = await dispatch(uploadEmp_SeparationFile(formData));
    //             if (response.success == true) {
    //                 showSnackbar(response.message.data.data.message, 'success');
    //                 setLoading(false);
    //                 fetchdata();
    //                 setFile(null);
    //             } else {
    //                 showSnackbar(response.message, 'warning');
    //                 setLoading(false);
    //             }
    //         } catch (error) {
    //             showSnackbar('An error occurred', 'error');
    //             setLoading(false);
    //         }
    //     }
    // };



const downloadBase64Excel = (contentBase64, filename) => {
    try {
        // Decode base64 to binary
        const byteCharacters = atob(contentBase64);
        const byteNumbers = new Array(byteCharacters.length);
        
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });
        
        // Create download link
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename || 'employee_separation_failed_rows.xlsx';
        document.body.appendChild(a); // Required for Firefox
        a.click();
        
        // Cleanup
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        
        console.log('Error file downloaded successfully:', filename);
    } catch (e) {
        console.error('Download failed:', e);
        showSnackbar('Failed to download error file. Please try again.', 'error');
    }
};

const handleFileUpload = async () => {
    if (!file) {
        showSnackbar('Please select a file to upload', 'warning');
        return;
    }
    
    setLoading(true);
    
    try {
        const response = await dispatch(uploadEmp_SeparationFile(file));
        console.log("Upload employee separation response:", response);
        
        // ============================================================
        // HANDLE SUCCESS RESPONSE (status 200)
        // ============================================================
        if (response.success === true) {
            const data = response.data; // This is the backend response object
            setActionChecked("create");
            
            // Check if we have the expected response structure
            if (!data) {
                showSnackbar('Unexpected response format', 'error');
                setLoading(false);
                return;
            }
            
            // Extract counts
            const insertedCount = data.updated_count || 0;
            const failedCount = data.failed_count || 0;
            const totalRows = insertedCount + failedCount;
            
            // CASE 1: Full success (all rows inserted)
            if (insertedCount > 0 && failedCount === 0) {
                showSnackbar(
                    data.message || `Successfully uploaded ${insertedCount} record(s)`, 
                    'success'
                );
                
                // Refresh the data table
                fetchdata();
                setFile(null);
            }
            
            // CASE 2: Partial success (some rows inserted, some failed)
            else if (insertedCount > 0 && failedCount > 0) {
                showSnackbar(
                    `Partial upload: ${insertedCount} of ${totalRows} record(s) added successfully. ` +
                    `${failedCount} record(s) failed. Downloading error file...`,
                    'warning',
                    6000 // Show for 6 seconds
                );
                
                // Download error file
                if (data.error_file && data.error_file.content_base64) {
                    downloadBase64Excel(
                        data.error_file.content_base64, 
                        data.error_file.filename
                    );
                } else {
                    console.warn('No error file in response despite failed rows');
                }
                
                // Refresh the data table (to show successfully inserted rows)
                fetchdata();
                // Don't clear the file - user might want to fix and re-upload
            }
            
            // CASE 3: Complete failure (all rows failed)
            else if (insertedCount === 0 && failedCount > 0) {
                showSnackbar(
                    `Upload failed: All ${failedCount} record(s) have validation errors. ` +
                    `Downloading error file with details...`,
                    'error',
                    6000
                );
                
                // Download error file
                if (data.error_file && data.error_file.content_base64) {
                    downloadBase64Excel(
                        data.error_file.content_base64, 
                        data.error_file.filename
                    );
                } else {
                    console.warn('No error file in response despite all rows failing');
                    // Fallback: show the message if available
                    if (data.message) {
                        showSnackbar(data.message, 'error', 8000);
                    }
                }
            }
            
            // CASE 4: Unexpected state (shouldn't happen but handle gracefully)
            else {
                showSnackbar(
                    data.message || 'Upload completed with unexpected result', 
                    'info'
                );
            }
            
            setLoading(false);
        }
        
        // ============================================================
        // HANDLE ERROR RESPONSE (non-200 status)
        // ============================================================
        else {
            const errorMsg = response.error || 'Upload failed';
            
            // Handle different error types
            if (typeof errorMsg === 'string') {
                showSnackbar(errorMsg, 'error');
            } else if (Array.isArray(errorMsg)) {
                // If backend returns array of errors
                const displayError = errorMsg.slice(0, 3).join('; ') + 
                    (errorMsg.length > 3 ? ` ... and ${errorMsg.length - 3} more errors` : '');
                showSnackbar(displayError, 'error');
            } else if (typeof errorMsg === 'object' && errorMsg.error) {
                showSnackbar(errorMsg.error, 'error');
            } else {
                showSnackbar('An error occurred during upload', 'error');
            }
            
            setLoading(false);
        }
        
    } catch (error) {
        // This catches any unexpected errors in the frontend code
        console.error('Upload error:', error);
        showSnackbar('An unexpected error occurred. Please try again.', 'error');
        setLoading(false);
    }
};







    const submitdelete = async (id) => {
        setLoading(true);
        try {
            const response = await dispatch(multiDeleteEmp_Separations(id));
            if (response.success == true) {
                showSnackbar(response.message.message, 'success');
                setLoading(false);
                fetchdata();
                setActionChecked("delete");
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }
    }

    const handleSaveClick = async (e) => {
        const empSeparationDate = editedValues.emp_separation_date;
        const empSeparationReason = editedValues.emp_separation_reason?.trim();
        if (!empSeparationDate){
            showSnackbar("Employee Separation Date cannot be Empty","warning");
            return;
        }
        if (!empSeparationReason){
            showSnackbar("Employee Separation Reason Cannot be Empty","warning");
            return;
        }
        setLoading(true);
        try {
            const response = await dispatch(updateEmp_SeparationById(editedValues.id, editedValues));
            if (response.success == true) {
                showSnackbar(response.message, 'success');
                setLoading(false);
                setEditableRow(null);
                fetchdata();
            } else {
                showSnackbar(response.message.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }
    };

    const handledeleteClickOpenalert = async (id) => {
        setLoading(true);
        try {
            const response = await dispatch(deleteEmp_SeparationById(id));
            if (response.success == true) {
                showSnackbar(response.message, 'success');
                setLoading(false);
                setEditableRow(null);
                fetchdata();
                setActionChecked("delete");
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }
    };
    const getUserPermission = async () => {
        try {
            const response = await dispatch(getUserRole());    
            const rawPermissions = response?.data?.permissions;
    
            const parsedPermissions = typeof rawPermissions === "string"
                ? JSON.parse(rawPermissions)
                : Array.isArray(rawPermissions) && typeof rawPermissions[0] === "string"
                    ? JSON.parse(rawPermissions[0])
                    : rawPermissions;
    
            parsedPermissions.forEach((item) => {
                const { section, module, sub_module } = item;
    
                if (section === "InputMatrix" && module === "InputMatrix") {
                    const employeePermission = sub_module.find(sub => sub.name === 'Employee Separation');
                    if (employeePermission?.action) {
                        setCreateData(employeePermission.action.create);
                        setEditData(employeePermission.action.edit);
                        setDeleteData(employeePermission.action.delete);
                    }
                }
            });
    
        } catch (err) {
            console.error("Failed to fetch permissions:", err);
        }
    };
    
    const fetchcurrmonth = async () => {
        try {
            const response = await dispatch(getCurrentMonth());
            if(date === new Date(response.data[0].current_month).toISOString().split('T')[0]){
                getUserPermission();
            }
        } catch (err) {
            console.error("Failed to fetch clients:", err);
        }
    };
    useEffect(() => {
        fetchcurrmonth();
    }, [dispatch]);
    return (
        <div className='container-fluid '>
            {/* <Reusabletable
                data={getData}
                header={header}
                setFile={setFile}
                handleFileUpload={handleFileUpload}
                submitdelete={submitdelete}
                handleSaveClick={handleSaveClick}
                setEditableRow={setEditableRow}
                editableRow={editableRow}
                setEditedValues={setEditedValues}
                editedValues={editedValues}
                handledeleteClickOpenalert={handledeleteClickOpenalert}
                title={'Employee Separation'}
                setLoading={setLoading}
                filestemp={files}
                showSnackbar={showSnackbar}
                date={date}
            /> */}
            {createData ? 
            // <ImportFileform
            //     setFiledata={setFile}
            //     title={'Employee Separation'}
            //     filestemp={files}
            //     handleFileUpload={handleFileUpload}

            // />
            <ImportFileformInputMatrix
                setFiledata={setFile}
                title={'Employee Separation'}
                filestemp={files}
                handleFileUpload={handleFileUpload}
                date={date}
                File={file}
            />:<ImportFileformInputMatrixclientData
                date={date}
                
            />
            }
            <EditableTable
            
            header={header}
            mainIcon={mainicon}
            title={'Employee Separation'}
            data={getData}
            setEditableRow={setEditableRow}
            setEditedValues={setEditedValues}
            handledeleteClickOpenalert={handledeleteClickOpenalert}
            editableRow={editableRow}
            setLoading={setLoading}
            editedValues={editedValues}
            getEditPermission = {editData}
            getDeletePermission = {deleteData}
            date={date}
            submitdelete={submitdelete}
            handleSaveClick={handleSaveClick}
            showSnackbar={showSnackbar}
            mainIconColor={"#81cb00"}
            actionChecked={actionChecked}
            setActionChecked={setActionChecked}
            createOrfilterComp={
                <></>
            }
            />
        </div>
    )
}


export default EmployeeSeparation
